module.exports = __webpack_public_path__ + "img/gts.700ecf84.png";